/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} More_EllipsisInputs */



/**
* | output |
* | --- |
* | "More..." |
*
* @param {More_EllipsisInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const more_ellipsis = /** @type {((inputs?: More_EllipsisInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<More_EllipsisInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Plus...")
	if (locale === "de") return /** @type {LocalizedString} */ ("Mehr...")
	if (locale === "it") return /** @type {LocalizedString} */ ("Di più...")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Более...")
	if (locale === "es") return /** @type {LocalizedString} */ ("Más...")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("更多的...")
	if (locale === "ja") return /** @type {LocalizedString} */ ("もっと...")
	if (locale === "hi") return /** @type {LocalizedString} */ ("अधिक...")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Mais...")
	return /** @type {LocalizedString} */ ("More...")
});